import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 7.81 245.91"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.1 244.8c.7.7 1.7 1.2 2.8 1.1 1 0 2-.4 2.8-1.1.7-.7 1.2-1.7 1.1-2.8V3.9c0-1-.4-2-1.1-2.8C6 .4 5 0 3.9 0c-1 0-2 .4-2.8 1.1C.4 1.9 0 2.9 0 3.9V242c0 1 .4 2 1.1 2.8",
  style: {"stroke-width":"0"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }